globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.modules = appVisitor.modules || {};

appVisitor.modules.Conversionable = (function() {

  function Conversionable() {
    this.$body = $('body');
    this.init();
  }

  Conversionable.prototype = {
    init : function() {
      var self = this;

      // PhoneNumberDisplayConversion
      this.$body.on('click', '.phone-number-display-conversion-tracking', function(){
        var $this = $(this);

        if ($this.closest('.phone-links-conversion-wrapper').length) {
          $this.fadeOut(200, function() {
            $this.siblings('.phone-number-link').fadeIn(200);
          });
        }

        var conversionOptions = $this.data('conversion-options');

        $.ajax({
          type: 'POST',
          url: $this.data('ajax-url'),
          data: {
            popup_id: conversionOptions.popupId,
            phone_number: conversionOptions.phoneNumber
          }
        })
      })

      // FileDownloadConversion
      this.$body.on('click', '.file-download-conversion-tracking', function() {
        var $this = $(this);
        var conversionOptions = $this.data('conversion-options');

        $.ajax({
          type: 'POST',
          url: $this.data('ajax-url'),
          data: {
            popup_id: conversionOptions.popupId,
            file_label: conversionOptions.fileLabel,
            source_file_name: conversionOptions.sourceFileName
          }
        })
      })

      // LinkOpenConversion: Simplebo all types of content_link
      this.$body.on('click', '.link-open-conversion-tracking', function() {
        var $this = $(this);
        var conversionOptions = $this.data('conversion-options');
        var linkText = conversionOptions.linkText || $this.text() || $this.attr('title');
        var linkType = self._setLinkType(conversionOptions.linkType);
        var linkOpenData = {
          popup_id: conversionOptions.popupId,
          link_url: conversionOptions.linkUrl,
          link_text: linkText,
          link_type: linkType
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })

      // LinkOpenConversion: Google Maps/GMB (for Simplébo floating menu)
      this.$body.on('click', '.floating-menu a.address-conversion-tracking[href*="google."][href*="/maps"]', function() {
        var $this = $(this);
        var linkType = self._setLinkType("external_link");
        var linkOpenData = {
          link_url: $this.attr('href'),
          link_text: $this.text(),
          link_type: linkType,
          targeted_external_platform: 'google_maps'
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })

      // LinkOpenConversion: Calendly popup opening floating button
      this.$body.on('click', '.calendly-badge-widget', function() {
        var $this = $(this);
        var linkType = self._setLinkType("external_link");
        var linkOpenData = {
          link_text: $this.text().replace('powered by Calendly', ''),
          link_type: linkType,
          targeted_external_platform: 'calendly'
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })

      // LinkOpenConversion: Crenolib floating button
      this.$body.on('click', '.crenolib', function() {
        var $this = $(this);
        var linkType = self._setLinkType("external_link");
        var linkOpenData = {
          link_url: $this.attr('href'),
          link_text: $this.text(),
          link_type: linkType
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })

      // LinkOpenConversion: Doctolib floating button
      this.$body.on('click', 'a[href*="doctolib"]:not(.content-link)', function() {
        if ($(this).closest('.element-sitemap').length === 0) {
          var $this = $(this);
          var linkType = self._setLinkType("external_link");
          var linkOpenData = {
            link_url: $this.attr('href'),
            link_text: $this.text(),
            link_type: linkType
          };

          self._sendLinkOpenCreateCall(linkOpenData);
        }
      })

      // LinkOpenConversion: Les avocats widget
      this.$body.on('click', 'a[href*="consultation.avocat.fr"]:not(.content-link)', function() {
        if ($(this).closest('.element-sitemap').length === 0) {
          var $this = $(this);
          var linkType = self._setLinkType("external_link");
          var linkOpenData = {
            link_url: $this.attr('href'),
            link_text: $this.text(),
            link_type: linkType
          }

          self._sendLinkOpenCreateCall(linkOpenData);
        }
      })

      // LinkOpenConversion: Médoucine button
      this.$body.on('click', 'a[href*="medoucine.com"]:not(.content-link)', function() {
        if ($(this).closest('.element-sitemap').length === 0) {
          var $this = $(this);
          var linkType = self._setLinkType("external_link");
          var linkOpenData = {
            link_url: $this.attr('href'),
            link_text: 'Prendre rendez-vous',
            link_type: linkType
          }

          self._sendLinkOpenCreateCall(linkOpenData);
        }
      })

      // LinkOpenConversion: Perfactive floating button
      this.$body.on('click', 'a[href*="perfactive.fr"]:not(.content-link)', function() {
        if ($(this).closest('.element-sitemap').length === 0) {
          var $this = $(this);
          var linkType = self._setLinkType("external_link");
          var linkOpenData = {
            link_url: $this.attr('href'),
            link_text: $this.text(),
            link_type: linkType
          }

          self._sendLinkOpenCreateCall(linkOpenData);
        }
      })

      // LinkOpenConversion: PrimoCreno button
      this.$body.on('click', 'a[href*="primocreno.com"]:not(.content-link)', function() {
        if ($(this).closest('.element-sitemap').length === 0) {
          var $this = $(this);
          var linkType = self._setLinkType("external_link");
          var linkOpenData = {
            link_url: $this.attr('href'),
            link_text: 'Prendre RDV',
            link_type: linkType
          }

          self._sendLinkOpenCreateCall(linkOpenData);
        }
      })

      // LinkOpenConversion: Resalib floating button and html injection
      this.$body.on('click', 'a[href*="www.resalib.fr/praticien/"]:not(.content-link)', function() {
        var $this = $(this);
        var linkType = self._setLinkType("external_link");
        var linkOpenData = {
          link_url: $this.attr('href'),
          link_text: $this.text(),
          link_type: linkType
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })

      // LinkOpenConversion: Whatsapp floating button
      this.$body.on("click", "a[href*='api.whatsapp.com/send?phone=']:not(.content-link)", function() {
        var $this = $(this);
        var linkType = self._setLinkType("external_link");
        var linkOpenData = {
          link_url: $this.attr("href"),
          link_text: "Whatsapp",
          link_type: linkType
        }

        self._sendLinkOpenCreateCall(linkOpenData);
      })
    },

    _sendLinkOpenCreateCall: function(linkOpenData) {
      $.ajax({
        type: 'POST',
        url: '/api-website-feature/conversions/link_open/create',
        data: linkOpenData
      });
    },

    _setLinkType: function(linkType) {
      switch (linkType) {
        case "page":
        case "blog":
          return "internal";
        case "popup":
          return "popup";
        case "external_link":
          return "external";
      }
    }
  }

  return Conversionable;
})();
